import React from 'react';

const PLATFORMS: Record<string, { glyph: string; colorVar: string; bgVar?: string }> = {
  bluesky:   { glyph: '🦋', colorVar: '--platform-bluesky' },
  instagram: { glyph: '📷', colorVar: '--platform-instagram' },
  facebook:  { glyph: 'f',  colorVar: '--platform-facebook' },
  tiktok:    { glyph: '♪',  colorVar: '--platform-tiktok', bgVar: '#000' },
  reddit:    { glyph: '⬆',  colorVar: '--platform-reddit' },
  twitter:   { glyph: '𝕏',  colorVar: '--platform-twitter' },
};

interface PlatformBadgeProps {
  platform: string;
}

export default function PlatformBadge({ platform }: PlatformBadgeProps) {
  const info = PLATFORMS[platform];
  if (!info) return <span className="badge">{platform}</span>;

  const style: React.CSSProperties = {
    '--badge-color': `var(${info.colorVar})`,
    ...(info.bgVar ? { background: info.bgVar, color: `var(${info.colorVar})` } : {}),
  } as React.CSSProperties;

  return (
    <span className="platform-badge platform-badge--branded" style={style}>
      <span className="platform-badge-icon" aria-hidden>{info.glyph}</span>
    </span>
  );
}
